import { FC } from 'react';

import { useNavigate } from 'react-router';

import { Modal } from '@/components';
import { LOAN_MAPPING_TOOLTIP, PFC_MAPPING_TOOLTIP, SHARE_MAPPING_TOOLTIP } from '@/constants';
import { APP_ROUTES } from '@/routes';

import { MappingCard } from './MappingCard';
import { MappingModalProps } from './types';

import styles from './styles.module.scss';

import ModalIllustration from '@/assets/icons/mapping-modal.svg?react';

export const MappingModal: FC<MappingModalProps> = ({ isOpen, onClose, onOverlayClick, modalData }) => {
  const navigate = useNavigate();

  const {
    shareCodesUnmappedCount,
    shareCodesTotalCount,
    loanCodesUnmappedCount,
    loanCodesTotalCount,
    pfcCodesUnmappedCount,
    pfcCodesTotalCount,
  } = modalData;

  const handleClose = (path: string) => {
    const isMappingRoute = path !== APP_ROUTES.aires;
    navigate(path, isMappingRoute ? { state: { fromMappingModal: true } } : undefined);

    if (!isMappingRoute) {
      onClose();
    }
  };

  return (
    <Modal
      title="Please Map Your Codes"
      isOpenModal={isOpen}
      onClose={onClose}
      onOverlayClick={onOverlayClick}
      showSubmitBtnExternal={false}
      showCancelBtnExternal={false}
      className={styles.modal}
      maxWidth="md"
    >
      <div className={styles.modalBody}>
        <div className={styles.mappingWrapper}>
          <p className={styles.modalSubtitle}>
            By providing the meaning of codes in your data, you will be able to perform more detailed analysis within
            the software.
          </p>

          <div className={styles.mappingsWrapper}>
            <MappingCard
              label="AIRES Files Submitted"
              description=""
              total={0}
              notMapped={0}
              handleClick={() => handleClose(APP_ROUTES.aires)}
            />

            {loanCodesTotalCount !== 0 && (
              <MappingCard
                label={loanCodesUnmappedCount !== 0 ? 'Provide Loan Mapping' : 'Loan Mapping Submitted'}
                description={LOAN_MAPPING_TOOLTIP}
                total={loanCodesTotalCount}
                notMapped={loanCodesUnmappedCount}
                handleClick={() => handleClose(APP_ROUTES.loansMapping)}
              />
            )}

            {shareCodesTotalCount !== 0 && (
              <MappingCard
                label={shareCodesUnmappedCount !== 0 ? 'Provide Share Mapping' : 'Share Mapping Submitted'}
                description={SHARE_MAPPING_TOOLTIP}
                total={shareCodesTotalCount}
                notMapped={shareCodesUnmappedCount}
                handleClick={() => handleClose(APP_ROUTES.sharesMapping)}
              />
            )}

            {pfcCodesTotalCount !== 0 && (
              <MappingCard
                label={
                  shareCodesUnmappedCount !== 0
                    ? 'Provide Payment Frequency Code Mapping'
                    : 'Payment Frequency Code Mapping Submitted'
                }
                description={PFC_MAPPING_TOOLTIP}
                total={pfcCodesTotalCount}
                notMapped={pfcCodesUnmappedCount}
                handleClick={() => handleClose(APP_ROUTES.codeMapping)}
              />
            )}
          </div>
        </div>

        <div className={styles.mappingImage}>
          <ModalIllustration />
        </div>
      </div>
    </Modal>
  );
};
